import classNames from 'classnames';
import React from 'react';
import styles from './styles.module.scss';
import icTrophyH from '@profile/assets/img/ic_trophy_h.png';
import icTrophyG from '@profile/assets/img/ic_trophy_g.png';
import icTrophyF from '@profile/assets/img/ic_trophy_f.png';
import icTrophyE from '@profile/assets/img/ic_trophy_e.png';
import icTrophyD from '@profile/assets/img/ic_trophy_d.png';
import icTrophyC from '@profile/assets/img/ic_trophy_c.png';
import icTrophyB from '@profile/assets/img/ic_trophy_b.png';
import icTrophyA from '@profile/assets/img/ic_trophy_a.png';
import icTrophyS from '@profile/assets/img/ic_trophy_s.png';
import icTrophySS from '@profile/assets/img/ic_trophy_ss.png';
import { HeroTrophy } from '@profile/src/utils/types';
const iconMap = {
  [HeroTrophy.SS]: icTrophySS,
  [HeroTrophy.S]: icTrophyS,
  [HeroTrophy.A]: icTrophyA,
  [HeroTrophy.B]: icTrophyB,
  [HeroTrophy.C]: icTrophyC,
  [HeroTrophy.D]: icTrophyD,
  [HeroTrophy.E]: icTrophyE,
  [HeroTrophy.F]: icTrophyF,
  [HeroTrophy.G]: icTrophyG,
  [HeroTrophy.H]: icTrophyH
};

const HeroTrophyIcon = ({
  className,
  small,
  value
}) => {
  return /*#__PURE__*/React.createElement("img", {
    className: classNames(className, styles.root, small && styles.small),
    src: iconMap[value]
  });
};

export default HeroTrophyIcon;